module.exports = __webpack_public_path__ + "fonts/Quicksand-Regular.cffc279.ttf";